module.exports = __webpack_public_path__ + "static/media/visuel_oeuf_2023.3df717d0.png";